import * as Sentry from "@sentry/browser";
import { SENTRY_DSN } from "./config";

const sampleRate = process.env.NODE_ENV === "production" ? 1 : 0; // Prevent logs in local/debug mode

const initialise = () =>
  Sentry.init({ dsn: SENTRY_DSN, sampleRate, environment: process.env.REACT_APP_ENV });

export { initialise };
